import { render, staticRenderFns } from "./TitleHomework.vue?vue&type=template&id=67190caa&scoped=true"
import script from "./TitleHomework.vue?vue&type=script&lang=js"
export * from "./TitleHomework.vue?vue&type=script&lang=js"
import style0 from "./TitleHomework.vue?vue&type=style&index=0&id=67190caa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67190caa",
  null
  
)

export default component.exports